export enum FireRating {
  UL20M = 'UL 20MIN',
  ULEMB = 'UL EMBOSSED',
  WHA = 'WHA 180 Minutes',
  WHB = 'WHB 90 Minutes',
  WHC = 'WHC 45 Minutes',
  WHS = 'WHS 20 Minutes',
}
